<template>
  <router-link :to="'/settings/' + to">
    <div class="settings-card card cursor-pointer">
      <div class="img-wrapper">
        <slot name="img"></slot>
      </div>
      <div class="card-details">
        <p class="title font-bold">{{ title }}</p>
        <p class="details text-grey">{{ details }}</p>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    details: {
      type: String,
      required: false,
    },
    to: {
      type: String,
      required: false,
      default: "#",
    },
  },
};
</script>

<style scoped>
.settings-card {
  transition: all ease 0.5s;
  border-radius: 5px;
  padding: 1rem;
  height: 100%;
}
.settings-card:hover {
  transform: scale(1.05);
}
.img-wrapper {
  margin: 0 auto;
}
.card-details {
  text-align: center;
  padding: 1rem 0;
}
.title {
  font-size: 1rem;
}
.details {
  padding-top: 0.5rem;
  font-size: 0.8rem;
}
a {
  color: initial;
  text-decoration: none;
  font-weight: normal;
}
a:hover {
  text-decoration: none;
}
</style>
